// extracted by mini-css-extract-plugin
export default {"container":"EvToPqk_tHXWm_pXZJdM","title":"WJs7Qd1BpDoO0F3Ph6O4","subtitle":"T8ivPkjce0kNULd0IYyB"};